import React, { Component, memo, Suspense } from 'react';

import {
  attemptStaleChunkSelfHeal,
  reportExhaustedChunkFailure,
} from 'utils/chunkLoadRecovery';
import { isOptionalChunkLoadError } from 'utils/lazyOptional';

class OptionalChunkErrorBoundary extends Component {
  state = { error: null, selfHealing: false };

  static getDerivedStateFromError(error) {
    return { error, selfHealing: false };
  }

  componentDidCatch(error) {
    if (!isOptionalChunkLoadError(error)) return;

    if (attemptStaleChunkSelfHeal(error)) {
      this.setState({ selfHealing: true });
      return;
    }

    reportExhaustedChunkFailure(error);
  }

  render() {
    const { children } = this.props;
    const { error, selfHealing } = this.state;

    if (!error) return children;
    if (!isOptionalChunkLoadError(error)) throw error;
    if (selfHealing) return null;

    return null;
  }
}

const OptionalLazyBoundary = memo(({ children, fallback = null }) => (
  <OptionalChunkErrorBoundary>
    <Suspense fallback={fallback}>{children}</Suspense>
  </OptionalChunkErrorBoundary>
));

OptionalLazyBoundary.displayName = 'OptionalLazyBoundary';

export default OptionalLazyBoundary;
